export function getLayout(state) {
	return state.get("layout");
}
